module.exports = __webpack_public_path__ + "img/sneks-painting.2fc2ab48.png";